import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs/Observable";
import {WatchService} from "./watch.service";
import {ModalService} from "./modal.service";


@Injectable()
export class UnsavedGuard implements CanDeactivate<any> {
    constructor(private watchService:WatchService,
                private modalService:ModalService) {}


    canDeactivate(component:any, route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean>
                        | Promise<boolean>
                        | boolean {
        if (this.watchService.hasChanges) {
            this.modalService.showUnsavedWarning();
            return false;
        }
        return true;
    }
}


// WEBPACK FOOTER //
// /opt/app/develop/src/app/services/unsaved-guard.service.ts